import React, { useContext, useState, useRef, useEffect } from 'react'
import { GetUserContext } from '../../Context/GetUserContext';
import { SetUserContext } from '../../Context/SetUserContext'
import { Card, CardFooter, CardBody } from 'react-bootstrap';
import { BsArrowBarRight } from "react-icons/bs";
import { RegisterRight } from './RegisterRight';
import RegisterLeft from './RegisterLeft';
import Logo from '../../img/logo_new.png'
import Carousel from 'react-bootstrap/Carousel';
import ControllLogin from '../../controller/api/Login';
import verifyDatas from '../../controller/views/verifyDatas'
import './SignupSection.css'
import AlertModal from '../AlertModal';

const SignupSection = () => {
    const { size, setToken, userDatas, setUserDatas, registerYourSelf, setRegisterYourSelf } = useContext(GetUserContext);
    const [cardSelectionRegister, setCardSelectionRegister] = useState(null);
    const [passwordUpdate, setPasswordUpdate] = useState(false);
    const [propShow, setPropShow] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const classLoger = new ControllLogin();

    let cardRegister01 = useRef('')
    let cardRegister02 = useRef('')

    const texts = () => {
        if (cardRegister01?.current?.id == "cardRegister01") {
            setCardSelectionRegister(true)
        } else if (cardRegister02?.current?.id == "cardRegister02") {
            setCardSelectionRegister(false)
        }
    }


    const handleLogin = (e) => {
        e.preventDefault();

        if (verifyDatas.isValid(email) && verifyDatas.isValid(password)) {

            classLoger.Login(email, password)
                .then(response => {

                    setPropShow(true);
                    setUserDatas(response);

                })
                .catch(error => {
                    setUserDatas(error);
                });
        }
    };

    const handleUpdatePassword = (e) => {
        e.preventDefault();

        if (verifyDatas.isValid(email) && verifyDatas.isValid(password) && verifyDatas.isValid(passwordConfirm)) {
            if (password === passwordConfirm) {

                classLoger.passwordUpdate(email, password)
                    .then(response => {
                        setPropShow(true);
                        setUserDatas(response);
                        setPasswordUpdate(false)
                    })
                    .catch(error => {
                        setUserDatas(error);
                    });

            } else {
                setUserDatas({ message: "Senhas divergentes", status: 401 })
                setPropShow(true);
            }
        }
    }





    return (
        <div className={`${!registerYourSelf ? 'section-main-login' : 'section-main'}`}>
            {
                registerYourSelf ?
                    (<>

                        {
                            size?.categoria !== 'xlarge' && size?.categoria !== 'large' && size?.categoria !== 'mid-large' && registerYourSelf === true ?
                                (
                                    <div className='area-cards-register-user-small position-relative '>
                                        <div id="radius-shape-1" className="position-absolute rounded-circle shadow-5-strong"></div>
                                        <div id="radius-shape-2" className="position-absolute shadow-5-strong"></div>
                                        <div id="radius-shape-4" className="position-absolute shadow-5-strong"></div>

                                        <br></br>
                                        <Card id="cardRegister02" ref={cardRegister02} className={` ${cardSelectionRegister ? 'card-register-leave' : 'card-register'}`} onClick={() => { setCardSelectionRegister(false) }}>
                                            <Card.Header className='text-center'><Card.Title><h5>Cadastro da Empresa</h5></Card.Title></Card.Header>
                                            <CardBody>
                                                <RegisterLeft />
                                            </CardBody>
                                            <CardFooter> </CardFooter>
                                        </Card>
                                        <BsArrowBarRight className='icon-between' style={{ fontSize: "2em", color: "#e5e5e5e5" }} />
                                        <br></br>
                                        <Card id="cardRegister01" ref={cardRegister01} className={`${cardSelectionRegister ? 'card-register' : ' card-register-leave'}`} onClick={texts}>
                                            <Card.Header className='text-center'><Card.Title><h5>Cadastro do Responsável</h5></Card.Title></Card.Header>
                                            <Card.Body className='area-card-body '> <RegisterRight />  </Card.Body>
                                        </Card>
                                    </div>
                                )
                                :
                                (
                                    <div className='area-cards-register-user position-relative hidden'>
                                        <div id="radius-shape-1" className="position-absolute rounded-circle shadow-5-strong"></div>
                                        <div id="radius-shape-2" className="position-absolute shadow-5-strong"></div>
                                        <div id="radius-shape-4" className="position-absolute shadow-5-strong"></div>

                                        <Card id="cardRegister02" ref={cardRegister02} className={`bg-glass ${cardSelectionRegister ? 'card-register-leave' : 'card-register'}`} onClick={() => { setCardSelectionRegister(false) }}>
                                            <Card.Header className='text-center'><Card.Title><h5>Cadastro da Empresa</h5></Card.Title></Card.Header>
                                            <Card.Body className='area-card-body '> <RegisterLeft /> </Card.Body>
                                        </Card>
                                        <BsArrowBarRight className='icon-between' style={{ fontSize: "2em", color: "#e5e5e5e5" }} />

                                        <Card id="cardRegister01" ref={cardRegister01} className={`bg-glass ${cardSelectionRegister ? 'card-register' : ' card-register-leave'}`} onClick={texts}>
                                            <Card.Header className='text-center'><Card.Title><h5>Cadastro do Responsável</h5></Card.Title></Card.Header>
                                            <Card.Body className='area-card-body '> <RegisterRight />  </Card.Body>
                                        </Card>
                                    </div>)
                        }


                    </>) :
                    (
                        <section className='hidden sec  '>
                            <div className=" sec-area-2 container px-4 py-5 px-md-5 text-center text-lg-start my-5 ">
                                <div className="sec-area-3 row gx-lg-5 align-items-center mb-5">

                                    {
                                        size?.categoria !== 'xlarge' && size?.categoria !== 'large' && size?.categoria !== 'mid-large' ?
                                            (<></>)
                                            :
                                            (<div className="col-lg-6 mb-5 mb-lg-0" style={{ zIndex: 10 }}>

                                                <Carousel className="custom-carousel" data-bs-theme="white" interval={10500} indicators={true}>
                                                    <Carousel.Item>
                                                        <h1 className="my-5 display-5 fw-bold ls-tight" style={{ color: "hsl(218, 81%, 95%)" }}>
                                                            Bem-vindo(a) à nossa plataforma!
                                                            <br />
                                                            <span className='text-white'></span>
                                                        </h1>
                                                        <p className="mb-4 opacity-70" style={{ color: "#e5e5e5", textAlign: "justify" }}>
                                                            Encontre tudo que você precisa em nossa plataforma completa para autopeças! Com um processo de compra simplificado e entrega rápida, garantimos agilidade e praticidade para manter seus veículos em perfeito funcionamento. Explore uma ampla seleção de peças e desfrute de uma experiência de compra otimizada e confiável, com suporte em cada etapa do seu pedido.
                                                        </p>
                                                    </Carousel.Item>
                                                    <Carousel.Item>
                                                        <h1 className="my-5 display-5 fw-bold ls-tight" style={{ color: "hsl(218, 81%, 95%)" }}>
                                                            Compra fácil, entrega rápida!<br />
                                                            <span className='text-white'></span>
                                                        </h1>

                                                        <p className="mb-4 opacity-70" style={{ color: "#e5e5e5", textAlign: "justify" }}>
                                                            Aproveite nossos preços competitivos e promoções exclusivas! Em nossa plataforma, você encontrará uma seleção diversificada de autopeças com condições imperdíveis. Não perca a oportunidade de economizar enquanto mantém seus veículos em perfeito estado. Compre agora e descubra as ofertas que preparamos especialmente para você!
                                                        </p>
                                                    </Carousel.Item>
                                                    <Carousel.Item>
                                                        <h1 className="my-5 display-5 fw-bold ls-tight" style={{ color: "hsl(218, 81%, 95%)" }}>
                                                            Suporte técnico para esclarecer dúvidas.<br />
                                                            <span className='text-white'></span>
                                                        </h1>

                                                        <p className="mb-4 opacity-70" style={{ color: "#e5e5e5", textAlign: "justify" }}>
                                                            Estamos aqui para oferecer suporte técnico dedicado e esclarecer todas as suas dúvidas! Se precisar de assistência na escolha de produtos, informações sobre instalação ou qualquer outra dúvida, não hesite em entrar em contato. Sua satisfação é nossa prioridade, e estamos aqui para garantir que você tenha a melhor experiência possível!
                                                        </p>
                                                    </Carousel.Item>
                                                </Carousel>
                                            </div>)
                                    }


                                    <div className=" sec-area-4 col-lg-5 mb-5 mb-lg-0 position-relative">
                                        <div id="radius-shape-1" className="position-absolute rounded-circle shadow-5-strong"></div>
                                        <div id="radius-shape-2" className="position-absolute shadow-5-strong"></div>
                                        <div id="radius-shape-3" className="position-absolute shadow-5-strong"></div>

                                        {
                                            passwordUpdate ?
                                                (
                                                    <div className="card bg-glass hidden ">
                                                        <br></br>
                                                        <div className='area-logo-singup'> <img src={Logo} /> </div>
                                                        <div className="card-body px-4 py-5 px-md-5">
                                                            <form onSubmit={handleUpdatePassword}>

                                                                <div className="form-outline mb-4">
                                                                    <label className="form-label" htmlFor="form3Example3">E-mail<span className='text-danger'>*</span></label>
                                                                    <input type="email" id="form3Example3" required onChange={(e) => { setEmail(e.target.value) }} className="form-control" />
                                                                </div>

                                                                <div className="form-outline mb-2">
                                                                    <label className="form-label" htmlFor="form3Example4">Senha<span className='text-danger'>*</span></label>
                                                                    <input type="password" id="form3Example4" required onChange={(e) => { setPassword(e.target.value) }} className="form-control" />
                                                                </div>

                                                                <div className="form-outline mb-4">
                                                                    <input type="password" id="form3Example4" placeholder='Confirme sua Senha' required onChange={(e) => { setPasswordConfirm(e.target.value) }} className="form-control" />
                                                                </div>

                                                                <button style={{ border: "trasparent" }} className="btn btn-warning btn-lg w-100  "> Redefinir </button>
                                                                <button onClick={() => { setPasswordUpdate(!passwordUpdate) }} className="btn btn-lg w-100"> Voltar </button>

                                                                <div className="text-center">
                                                                    <p onClick={() => { setRegisterYourSelf(true) }} style={{ textDecoration: "underline", cursor: "pointer" }} > ou faça o seu cadastro </p>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                ) :
                                                (
                                                    size?.categoria == "mid" || size?.categoria == "small" ?
                                                        (<div className="card bg-glass card-login card-login-mobile">
                                                            <br></br>
                                                            <div className='area-logo-singup'> <img src={Logo} /> </div>
                                                            <br></br>
                                                            <div className="card-body-small">
                                                                <form onSubmit={handleLogin}>
                                                                    <div className="form-outline mb-4">
                                                                        <label className="form-label" htmlFor="form3Example3">E-mail<span className='text-danger'>*</span></label>
                                                                        <input type="email" id="form3Example3" required onChange={(e) => { setEmail(e.target.value) }} className="form-control" />
                                                                    </div>
                                                                    <div className="form-outline mb-4">
                                                                        <label className="form-label" htmlFor="form3Example4">Senha<span className='text-danger'>*</span></label>
                                                                        <input type="password" id="form3Example4" required onChange={(e) => { setPassword(e.target.value) }} className="form-control" />
                                                                    </div>
                                                                    <div className="form-check d-flex justify-content-between mb-4">
                                                                        <div> </div>
                                                                        <div style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => { setPasswordUpdate(!passwordUpdate) }}>Redefinir Senha</div>
                                                                    </div>
                                                                    <button className="btn btn-warning btn-lg w-100"> Entrar </button>
                                                                    <div className="text-center">
                                                                        <br></br>
                                                                        <p onClick={() => { setRegisterYourSelf(true) }} style={{ textDecoration: "underline", cursor: "pointer" }} > ou faça o seu cadastro </p>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>)
                                                        :
                                                        (
                                                            <div className="card card-login bg-glass ">
                                                                <br></br>
                                                                <div className='area-logo-singup'> <img src={Logo} /> </div>
                                                                <div className="card-body px-4 py-5 px-md-5">
                                                                    <form onSubmit={handleLogin}>
                                                                        <div className="form-outline mb-4">
                                                                            <label className="form-label" htmlFor="form3Example3">E-mail<span className='text-danger'>*</span></label>
                                                                            <input type="email" id="form3Example3" required onChange={(e) => { setEmail(e.target.value) }} className="form-control" />
                                                                        </div>
                                                                        <div className="form-outline mb-4">
                                                                            <label className="form-label" htmlFor="form3Example4">Senha<span className='text-danger'>*</span></label>
                                                                            <input type="password" id="form3Example4" required onChange={(e) => { setPassword(e.target.value) }} className="form-control" />
                                                                        </div>
                                                                        <div className="form-check d-flex justify-content-between mb-4">
                                                                            <div>
                                                                                <input className="form-check-input me-2" type="checkbox" value="" id="form2Example33" defaultChecked />
                                                                                <label className="form-check-label" htmlFor="form2Example33"> Permanecer Conectado </label>
                                                                            </div>
                                                                            <div style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => { setPasswordUpdate(!passwordUpdate) }}>Redefinir Senha</div>
                                                                        </div>
                                                                        <button className="btn btn-warning btn-lg w-100"> Entrar </button>
                                                                        <div className="text-center">
                                                                            <br></br>
                                                                            <p onClick={() => { setRegisterYourSelf(true) }} style={{ textDecoration: "underline", cursor: "pointer" }} > ou faça o seu cadastro </p>
                                                                        </div>
                                                                    </form>
                                                                </div>
                                                            </div>
                                                        )

                                                )
                                        }


                                    </div>
                                </div >
                            </div >
                        </section >
                    )
            }

            <AlertModal
                propShow={propShow}
                setPropShow={setPropShow}
                status={userDatas?.status}
                message={userDatas?.message}
            />

        </div >
    )
}

export default SignupSection